exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".viewPanelContentWrapper_7kWWeWHJei1y6Gudh1OUq {\n  padding: 0 40px;\n  box-sizing: border-box;\n}\n\n.viewPanelContentWrapper_7kWWeWHJei1y6Gudh1OUq .section_3kxXSmHdwRCAZ0349f6JPL {\n  float: left;\n  clear: both;\n  margin-bottom: 15px;\n}\n\n.viewPanelContentWrapper_7kWWeWHJei1y6Gudh1OUq .infoText_3n-X6nyR1abFXUvbImjVNc {\n  float: left;\n  clear: both;\n  margin-bottom: 15px;\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"viewPanelContentWrapper": "viewPanelContentWrapper_7kWWeWHJei1y6Gudh1OUq",
	"section": "section_3kxXSmHdwRCAZ0349f6JPL",
	"infoText": "infoText_3n-X6nyR1abFXUvbImjVNc"
};